<template>
  <div id="app" class="home">

    <div class="header">
      <van-row>
        <van-col span="24">
          <form action="/">
            <van-search background="#fff"  v-model="search_keywords"  placeholder="请输入商品名称"  @search="onSearch" />
          </form>
        </van-col>
      </van-row>
    </div>
    <div style="padding-top: 50px" class="van-content clear">

      <van-swipe :autoplay="3000">
      <van-swipe-item v-for="items in datas.banner" :key="items.id">
        <a :href="items.ad_link">
          <img :src="items.img" onerror="src='/static/errorimg4.png'"/>
        </a >
      </van-swipe-item>
    </van-swipe>
      <!--导航列表-->
      <van-tabbar class="homenav">
        <van-tabbar-item @click="goican()">
          <span>我能兑换</span>
          <template slot="icon" slot-scope="props">
            <div class="navimgbox">
              <img src="/static/images/navimg12.png" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item :to="{path:'/goodsList',query:{sales_nums:1}}">
          <span>兑换排行</span>
          <template slot="icon" slot-scope="props">
            <div class="navimgbox">
              <img src="/static/images/navimg11.png" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/user/collect">
          <span>我的收藏</span>
          <template slot="icon" slot-scope="props">
            <div class="navimgbox">
              <img src="/static/images/navimg13.png" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/Adventures">
          <span>积分活动</span>
          <template slot="icon" slot-scope="props">
            <div class="navimgbox">
              <img src="/static/images/navimg14.png" />
            </div>
          </template>
        </van-tabbar-item>
      </van-tabbar>
      <!--大转盘-->
      <!--<van-cell-group><router-link to="/havefun"><img src="/static/images/lotterybanner2.png" onerror="src='/static/errorimg2.png'" /></router-link></van-cell-group>-->
      <!--<van-cell-group style="margin:10px 0 0 0;padding: 0 10px;"><router-link to="/Adventures"><img src="/static/images/turntable.png" onerror="src='/static/errorimg2.png'" /></router-link></van-cell-group>-->
      <!--限时抢购-->
      <van-cell-group class="plate xianshi" v-if="datas.xianshi && datas.xianshi.goods != ''">
        <router-link :to="{path:'/count',query:{is_rob:1}}" class="mui-navigate-right">
          <van-cell class="title">
            限时抢购
          </van-cell>
        </router-link>
        <van-swipe :autoplay="0" :loop="false" :show-indicators="false">
          <van-swipe-item   v-for="(items,index) in datas.xianshi.goods"  :key="items.id">
            <router-link :to="{path:'/goodsList/goods',query:{id:items.id}}" class="bannerbox">
              <img onerror="src='/static/errorimg1.png'" :src="items.img" />
              <div>
                <p class="countbox no-margin" v-if="(items.end_time-items.time) > 1">
                  <span v-show="parseInt((items.end_time-items.time)/(24*60*60))>1" class="no-padding"><span class="theme-bg">{{ parseInt((items.end_time-items.time)/(24*60*60)) }}</span><span class="dot2 theme-col">:</span></span>
                  <span class="no-padding"><span class="theme-bg">{{ parseInt((items.end_time-items.time)/(60*60)%24) }}</span><span class="dot2 theme-col">:</span></span>
                  <span class="no-padding"><span class="theme-bg">{{ parseInt((items.end_time-items.time)/(60)%60) }}</span><span class="dot2 theme-col">:</span></span>
                  <span class="no-padding"><span class="theme-bg">{{ parseInt((items.end_time-items.time)/(1)%60) }}</span></span>
                </p>
                <p class="countbox" v-if="(items.end_time-items.time) > 1">
                  <span class="havePadding"  v-show="parseInt((items.end_time-items.time)/(24*60*60))>1">天</span>
                  <span class="havePadding" >时</span>
                  <span class="havePadding" >分</span>
                  <span class="no-padding" >秒</span>
                </p>
                <p style="height: 38px" v-else="(items.end_time-items.time) > 1000" class="col-999">已兑完</p>
                <p class="ellipse product-name"><span plain class="theme-col radius  theme-bg jd" v-if="items.dummy == 3">京东</span>{{ items.product_name }}</p>
                <p class="theme-col product-price">{{ items.points_price  }}</p>
              </div>
            </router-link>
          </van-swipe-item>
        </van-swipe>
      </van-cell-group>


      <!--积分+现金-->
      <van-cell-group class="plate" v-if="datas.money_price && datas.money_price.goods != ''">
        <router-link :to="{path:'/goodsList',query:{is_money:1}}" class="mui-navigate-right">
          <van-cell class="title">
            积分+现金<i class="van-icon iconfont icon-gengduo"></i>
          </van-cell>
        </router-link>
        <van-row>
          <van-col span="8" v-for="items in datas.money_price.goods" :key="items.id">
            <router-link :to="{path:'/goodsList/goods',query:{id:items.id}}">
              <img onerror="src='/static/errorimg1.png'" :src="items.img" />
              <div>
                <p class="tagbox">
                  <!--<van-tag class="theme-bg theme-bd" v-if="items.is_new == 1">新品</van-tag>-->
                  <!--<van-tag class="theme-bg theme-bd" v-if="items.is_hot == 1">热销</van-tag>-->
                  <!--<van-tag class="theme-bg theme-bd" v-if="items.is_rob == 1">限时</van-tag>-->
                </p>
                <!--<p class="ellipse product-name"><van-tag plain class="theme-col theme-bd jd" v-if="items.dummy == 3">京东</van-tag>{{ items.product_name }}</p>-->
                <p class="theme-col product-price">{{ items.points_price  }}</p>
              </div>
            </router-link>
          </van-col>
        </van-row>
      </van-cell-group>
      <!--分类推荐-->
      <van-cell-group style="margin-bottom: 0;" class="plate" v-if="datas.fenlei && datas.fenlei.goods != ''">
        <router-link :to="{path:'/goodsList',query:{type:datas.fenlei.type}}" class="mui-navigate-right">
          <van-cell class="title">
            <!--分类推荐<i class="van-icon iconfont icon-gengduo"></i>-->
            分类推荐
          </van-cell>
        </router-link>
        <van-row v-for="item in datas.fenlei" :key="item.id">
          <div class="banner-img-box">
            <router-link :to="{path:'/goodsList',query:{cat_id:item.id}}">
              <img :src="item.banner_img" onerror="src='/static/errorimg2.png'"/>
            </router-link>
          </div>
          <van-col style="border: 3px solid #fff;padding-bottom: 10px;margin-bottom: 5px;" span="8" v-for="items in item.product_data" :key="items.id">
            <router-link :to="{path:'/goodsList/goods',query:{id:items.id}}">
              <img onerror="src='/static/errorimg1.png'" :src="items.img" />
              <div>
                <p   class="tagbox">
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_new == 1">新品</span>-->
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_hot == 1">热销</span>-->
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_rob == 1">限时</span>-->
                  <!--<span plain class="theme-col theme-bd jd  radius" v-if="items.dummy == 3">京东</span>-->
                </p>
                <p class="ellipse product-name">{{ items.product_name }}</p>
                <p class="theme-col product-price">{{ items.points_price  }}{{ configData.currency }}</p>
              </div>
            </router-link>
          </van-col>
        </van-row>
      </van-cell-group>
      <!--专题精选-->
      <!--<van-cell-group class="plate zhuanti" v-if="datas.special.length!=0 && datas.special.goods != ''">-->
      <!--&lt;!&ndash;<router-link :to="{path:'/goodsList',query:{type:datas.special.type}}" class="mui-navigate-right">&ndash;&gt;-->
      <!--<router-link to="/" class="mui-navigate-right">-->
      <!--<van-cell  style="padding: 0 10px 10px 10px;" class="title">-->
      <!--专题精选&lt;!&ndash;<i class="van-icon iconfont icon-gengduo"></i>&ndash;&gt;-->
      <!--</van-cell>-->
      <!--</router-link>-->
      <!--<van-swipe :autoplay="0" :loop="false" :show-indicators="false">-->
      <!--<van-swipe-item style="background: #eff3f6;" v-for="(items,index) in datas.special" :key="items.id">-->
      <!--<router-link :to="{path:'/havefun',query:{id:items.id}}" class="bannerbox">-->
      <!--<img :src="items.banner" />-->
      <!--<p class="ft3 ellipse">{{ items.name }}</p>-->
      <!--<p class="col-666 ellipse">{{ items.intro }}</p>-->
      <!--</router-link >-->
      <!--</van-swipe-item>-->
      <!--</van-swipe>-->
      <!--</van-cell-group>-->
      <!--精品推荐-->
      <!--<van-cell-group class="plate" >-->
        <!--<router-link :to="{path:'/goodsList',query:{is_recommend:1}}" class="mui-navigate-right">-->
          <!--<van-cell style="padding: 0 10px" class="title">-->
            <!--&lt;!&ndash;精品推荐<i class="van-icon iconfont icon-gengduo"></i>&ndash;&gt;-->
            <!--精品推荐-->
          <!--</van-cell>-->
        <!--</router-link>-->
        <!--<van-list v-model="loading" :finished="finished" @load="getGoods" :offset="-1">-->
          <!--<van-cell style="padding: 10px 10px 0 10px;">-->
            <!--<van-col span="12" v-for="(items,index) in datass" :key="index" >-->
              <!--<router-link  :to="{path:'/goodslist/goods',query:{id:items.id}}">-->
                <!--&lt;!&ndash;<img v-lazy="items.product_img" />&ndash;&gt;-->
                <!--<div class="img-bg"><img :src="items.product_img" onerror="src='/static/errorimg1.png'"/></div>-->
                <!--<div>-->
                  <!--<p  class="tagbox">-->
                    <!--&lt;!&ndash;<span class="theme-bg radius  " v-if="items.is_new == 1">新品</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span class="theme-bg radius  " v-if="items.is_hot == 1">热销</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span class="theme-bg radius  " v-if="items.is_rob == 1">限时</span>&ndash;&gt;-->
                    <!--<span class="theme-col radius jd  theme-bg" v-if="items.dummy == 3">京东</span>-->
                  <!--</p>-->
                  <!--<p class="ellipse product-name">{{ items.product_name }}</p>-->
                  <!--<p class="theme-col product-price">{{ items.points_price  }}</p>-->
                <!--</div>-->
              <!--</router-link>-->
            <!--</van-col>-->
            <!--<div style="padding: 7px 0 10px 0;" v-if="!loading && finished" class="nomore"><span>已经到底了</span></div>-->
          <!--</van-cell>-->
        <!--</van-list>-->
      <!--</van-cell-group>-->

      <!--实物商品-->
      <van-cell-group  class="plate" v-if="shiwu!=undefined&& shiwu!= ''" >
        <router-link :to="{path:'/goodsList',query:{dummy:0}}" class="mui-navigate-right">
          <van-cell style="padding:10px 10px 0 10px" class="title">
            <!--精品推荐<i class="van-icon iconfont icon-gengduo"></i>-->
            实物推荐
          </van-cell>
        </router-link>
        <van-list>
          <van-cell style="padding: 10px 10px 0 10px;">
            <van-col span="12" v-for="(items,index) in shiwu" :key="index" >
              <router-link  :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <!--<img v-lazy="items.product_img" />-->
                <div class="img-bg"><img :src="items.img" onerror="src='/static/errorimg1.png'"/></div>
                <div>
                  <p  class="tagbox">
                    <!--<span class="theme-bg radius  " v-if="items.is_new == 1">新品</span>-->
                    <!--<span class="theme-bg radius  " v-if="items.is_hot == 1">热销</span>-->
                    <!--<span class="theme-bg radius  " v-if="items.is_rob == 1">限时</span>-->
                    <span  class="theme-col radius jd  theme-bg" v-if="items.dummy == 3">京东</span>
                  </p>
                  <p class="ellipse product-name">{{ items.product_name }}</p>
                  <p class="theme-col product-price">{{ items.points_price  }}积分</p>
                </div>
              </router-link>
            </van-col>
            <div style="padding: 7px 0 10px 0;" v-if="!loading && finished" class="nomore"><span>已经到底了</span></div>
          </van-cell>
        </van-list>
      </van-cell-group>
      <!--虚拟商品-->
      <van-cell-group  class="plate" v-if="xuni!=undefined&& xuni!= ''" >
        <router-link :to="{path:'/goodsList',query:{dummy:1}}" class="mui-navigate-right">
          <van-cell style="padding:0px 10px 0 10px " class="title">
            <!--精品推荐<i class="van-icon iconfont icon-gengduo"></i>-->
            虚拟卡券
          </van-cell>
        </router-link>
        <van-list>
          <van-cell style="padding: 10px 10px 0 10px;">
            <van-col span="12" v-for="(items,index) in xuni" :key="index" >
              <router-link  :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <!--<img v-lazy="items.product_img" />-->
                <div class="img-bg"><img :src="items.img" onerror="src='/static/errorimg1.png'"/></div>
                <div>
                  <p  class="tagbox">
                    <!--<span class="theme-bg radius  " v-if="items.is_new == 1">新品</span>-->
                    <!--<span class="theme-bg radius  " v-if="items.is_hot == 1">热销</span>-->
                    <!--<span class="theme-bg radius  " v-if="items.is_rob == 1">限时</span>-->
                    <span class="theme-col radius jd  theme-bg" v-if="items.dummy == 3">京东</span>
                  </p>
                  <p class="ellipse product-name">{{ items.product_name }}</p>
                  <p class="theme-col product-price">{{ items.points_price  }}积分</p>
                </div>
              </router-link>
            </van-col>
            <div style="padding: 7px 0 10px 0;" v-if="!loading && finished" class="nomore"><span>已经到底了</span></div>
          </van-cell>
        </van-list>
      </van-cell-group>
    </div>
    <!--底部导航-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
  import Vue from 'vue'
  import FooterNav from '@/components/footernav'
  import { Swipe, SwipeItem } from 'mint-ui';
  import { Dialog } from 'vant';

  Vue.component(Swipe.name, Swipe);
  Vue.component(SwipeItem.name, SwipeItem);
  export default {
    name: "detail",
    components: {
      FooterNav
    },
    props:['configData','userConfig'],
    data () {
      return {
        datas:'',
        datass:[],
        firstban:{img:'',ad_link:''},
        lastban:{img:'',ad_link:''},
        search_keywords:'',
        loading:false,
        finished:false,
        page:0,
        moreDay:0,
        search_keywords:'',
        fullHeight: document.documentElement.clientHeight,
        topOr:false,
        shiwu:'',
        xuni:'',
      }
    },
    methods: {
      goican:function(){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Login/Index/select_login', {token:isUser}, res => {
          if(res.data.errCode == '0000'){
            this.$router.push({path:'/goodsList',query:{'my_point':1}})
          }else{
            this.$router.push({ name: 'Login' })
          }
        })
      },
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {

      },
      getdatas:function () {
        this.$api.get('WebApi', null, res => {
          this.datas = res.data.data
          this.countDown()
          if(res.data.data.real_goods!=undefined){
            this.shiwu=res.data.data.real_goods.goods;
          }
          if(res.data.data.virtual_goods!=undefined){
            this.xuni=res.data.data.virtual_goods.goods;
          }
        })
      },
      getGoods:function () {
        var _this = this
        setTimeout(() => {
          this.page++
          this.$api.get('WebApi/Index/Index/selected', {p:this.page}, res => {
            if(res.data.data.datas.length==0){
              this.finished = true;
              this.loading = false;
            }else{
              for (let i = 0; i < res.data.data.datas.length; i++) {
                this.datass.push(res.data.data.datas[i]);

              }
              this.loading = false;
            }
          })
        },50)
      },
      countDown: function () {
        if(this.datas.xianshi && this.datas.xianshi.goods != ''){
          var _this = this;
          for(let i=0;i<_this.datas.xianshi.goods.length;i++){
            if(_this.datas.xianshi.goods[i].time != undefined){
              setInterval(function () {
                if(_this.datas.xianshi.goods[i].time < _this.datas.xianshi.goods[i].end_time){
                  var counttime = _this.datas.xianshi.goods[i].time + 1
                  _this.datas.xianshi.goods[i].time = counttime
                }else{
                  _this.datas.xianshi.goods[i].time = "时间到"
                }
              },1000)
            }
          }
        }
      },
      onSearch: function () {
        if( this.search_keywords != undefined && this.search_keywords != '' ){
          this.$router.push({path:'/goodslist',query:{'search_keywords':this.search_keywords}});
        }else{
          this.$toast('请输入要搜索的商品');
        }
      },
      getUser:function(){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {
            if(res.data.errCode == '0000'){
              this.$store.commit('userinfo')
              console.log('000000', this.userConfig.reset_password)
              if(!res.data.data.memberinfo.mobile) {
                Dialog.alert({
                  title: '提示 ',
                  message: '请先绑定手机号'
                }).then(() => {
                  this.$router.push({ name: 'BindMobile' })
                })
                return
              }
              if(res.data.data.memberinfo.reset_password == 0) {
                Dialog.alert({
                  title: '提示 ',
                  message: '为了保障您的账户安全，首次登录时，您需要进行密码重置操作。'
                }).then(() => {
                  this.$router.push({ name: 'Password' })
                })
              }
            }else if(res.data.errCode == '0002'){
              Dialog.alert({
                title: '提示 ',
                message: '用户已停用，请联系管理员！'
              }).then(() => {
                WeixinJSBridge.call('closeWindow');
              })
            }else{
              this.$router.push({ name: 'Login' })
              document.body.removeChild(document.getElementById('Loading'))
              // window.location.href = root + '/WebApi/Index/Index/weixinlogin?redirect=' + window.location.href;
            }

        })
      },
    },
    mounted () {
      this.getUser()
      this.getdatas()
    },
  };
</script>
<style lang="less">
  .home{
    background:#eff3f6 ;
    .van-notice-bar__right-icon{
      font-size: 1.2rem;
    }
    .navimgbox img{
      width: 60px!important;
      height: 60px!important;
    }
    .signintag{
      background: #fa2924;
      width: 60px;
      display: inline-block;
      position: absolute;
      z-index: 1;
      right: 0;
      margin-top: 20px;
      overflow: hidden;
      border-radius: 16px 0 0 16px;
      box-shadow: 0px 1px 6px -1px #333;
    }

    .zhuanti{
      overflow: hidden;
      .van-swipe{
        overflow: initial;
        width: 80%;
        padding-bottom: 15px;
      }
      .bannerbox{
        display: inline-block;
        padding: 0 10px;
        p{
          margin-top: 5px;
        }
      }
    }
    .xianshi{
      overflow: hidden;
      .van-swipe-item {
        -webkit-transform: translateX(0px) !important;
        transform: translateX(0px) !important;

      }
      .van-swipe{
        overflow: initial;
        width: 38%;
        padding-bottom: 10px;
        .countbox{
          span{
            text-align: center;
            display: inline-block;
            border-radius: 2px;
            padding: 0px 4px 0px 3px;
            box-sizing: border-box;
            min-width: 23px;
          }
        }
        .bannerbox{
          background: #fff;
          margin-left: 10px;
          display: inherit;
          border: 3px solid #fff;
          img{
            margin-bottom: 5px;
            height: 33vw;
          }
          p{
            margin-bottom: 5px;
          }
        }
      }
    }
    .newsbanner{
      margin: 10px 0;
      height: 36px;
      .inform{
        background-color: #fff;
        .van-notice-bar__left-icon{
          margin-right: 5px;
          .iconfont{
            vertical-align: baseline;
          }
        }
        .van-notice-bar__right-icon{
          left: 45px;
          top: 5px;
        }
      }
    }
    .myjifen{
      line-height: 30px;
      background-color: #fff;
      .van-icon{
        vertical-align: middle;
        margin-right: 5px;
        font-size: 1.6rem;
      }
    }
    .indexbannerbot{
      position: relative;
      margin-top: -30px;
    }
    .homenav{
      position: relative;
      height: auto;
      padding: 10px 0;
      .van-tabbar-item__icon{
        img{
          height: auto;
          width: 30px;
        }
      }
      .van-tabbar-item__text{
        position: relative;
        top:-10px;
      }
    }
    .plate {
      .van-row{
        padding: 0 10px;
        .banner-img-box{
          padding: 0;
          padding-bottom: 10px;
        }
      }
      .van-col{
        float: none;
        display: inline-block;
        vertical-align: top;
        padding-top: 0;
        background: #fff;
        img{
          margin-bottom: 5px;
        }

        .product-name{
          margin-bottom: 5px;
          font-size: 1.4rem;
        }
        .tagbox{
          height: 24px!important;
          margin-bottom: 5px;
        }
      }
      .van-col--12 {
        width: 49%;
        img{
          height: 45vw;
        }
      }
      .van-col--8 {
        width: 32.6666%;
        margin-right: 1%;
      }
      .van-col--8:nth-child(4n){
        margin-right: 0!important;

      }
      .van-col--12:nth-child(2n){
        margin-left: 1%;
        margin-bottom: 2.5vw;
      }
      .van-col--12:nth-child(2n-1){
        margin-right: 1%;
        margin-bottom: 2.5vw;
      }
      .title{
        .van-cell__value{
          text-align: center;
          font-size: 1.8rem;
          .van-icon{
            vertical-align: initial;
            margin-left: 5px;
          }
        }
        .van-cell__value{
          font-size: 1.5rem;
        }
      }
    }
    .van-hairline--top-bottom::after{
      border-width: 0;
    }
    .no-padding{
      padding: 0!important;
      color: #878787;
      font-size: 12px;
    }
    .no-margin{
      margin: 0!important;
    }
    .havePadding{
      padding-right: 12px!important;
      margin-left: 2px!important;
      padding-top: 0!important;
      color: #878787;
      font-size: 12px;
    }
    .dot2{
      padding: 0 0 0 3px!important;
      font-weight: bold;
      min-width: 5px!important;
    }
    .srollCont{
      position: relative;
    }
    .srollRight{
      position: absolute;
      right: 5px;
      top: 4px;
      width: 12px;
      height: 12px;
    }
    .radius {
      padding: 0 5px 1px!important;
      -webkit-border-radius:10px 0;
      -moz-border-radius:10px 0;
      border-radius:10px 0 ;

    }
    .plate .title .van-cell__value {
      background:url("/static/images/alone-bg.png") no-repeat center ;
      -webkit-background-size:100% 100%;
      background-size:40% 40%;

    }
    .nomore {
      background: #eff3f6!important;
      position: relative;
    }

    .van-col.van-col--12{
      border: 3px solid #fff;
    }
    .van-swipe-item{
      /*background: #fff;*/
    }
    .header{
      background: #fff;
      width: 100%;
      position: fixed;
      top:0;
      left:0;
      z-index: 1000;
      .van-field{
        border-radius:5px;
        background: #F0F0F0;
      }
    }
    [class*=van-hairline]::after,[class*=van-hairline]::before {
      height: 0!important;
      border:none;
    }
    /*.bannerbox {*/
      /*background: #fff!important;*/
      /*padding: 0 0 10px 0!important;*/
      /*!*margin:0 0 0 10px ;*!*/
    /*}*/
    .totop{
      width: 38px;
      height: 38px;
      border-radius: 50%;
      position: fixed;
      bottom:56px;
      right: 10px;
      background: #ddd;
      text-align: center;
    }
    .totop i{
      font-size: 22px;
      line-height: 38px;
      color: #fff!important;
    }


  }

</style>






// WEBPACK FOOTER //
// src/pages/user/index.vue